/* eslint-disable @typescript-eslint/no-non-null-assertion, react-hooks/exhaustive-deps */
import * as React from 'react';

import { ActionAfterViewed } from '@cian/action-after-viewed-component';

import { Tabs } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { Layout } from '../../components/Layout';
import { Promo, Header, RealtyValuation } from '../../components/RealtyValuation';
import { VALUATION_TABS } from '../../constants/realtyValuation';
import { getLastUpdateDate, getPromoText, getRealtyValuation } from '../../selectors/realtyValuation/';
import { getValuationTabs } from '../../utils/realtyValuation';
import { Charts } from './Charts';
import { SummariesContainer } from './Summaries';
import { trackShowPriceHistoryBlock } from './tracking';

export function RealtyValuationContainer() {
  const [activeTab, setActiveTab] = React.useState(VALUATION_TABS[0].id);
  const onTabClick = React.useCallback(value => {
    setActiveTab(value);
  }, []);

  const realtyValuation = useSelector(getRealtyValuation);

  if (!realtyValuation) {
    return null;
  }

  const promoText = getPromoText(realtyValuation);
  const lastUpdateDate = getLastUpdateDate(realtyValuation);
  const tabs = getValuationTabs(realtyValuation);

  return (
    <ActionAfterViewed callback={trackShowPriceHistoryBlock}>
      <RealtyValuation>
        <Layout>
          <Header aside={lastUpdateDate} />
          {!!promoText && <Promo text={promoText.text} emojiUrl={promoText.emojiUrl} />}
          <SummariesContainer />
          <Tabs
            activeTab={activeTab}
            onChange={onTabClick}
            tabs={tabs.map(item => ({
              value: item.id,
              title: item.title,
            }))}
          />
          <Charts activeTab={activeTab} />
        </Layout>
      </RealtyValuation>
    </ActionAfterViewed>
  );
}
